import { Skeleton } from '@/components/ui/skeleton'

const SkeletonMessage = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-4 p-4 border-4 border-gray-100 rounded-lg">
      <Skeleton className="w-full h-[36px] rounded-full" />
      <Skeleton className="w-full h-[16px] rounded-full" />
      <Skeleton className="w-full h-[16px] rounded-full" />
      <Skeleton className="w-full h-[16px] rounded-full" />
    </div>
  )
}

export default SkeletonMessage
